import React from "react";
import "./landing.css";
import WaveBackground from "./WaveBackground";
import { testimonialsData } from "./testimonialsData";
import { APP_DOMAIN } from '../../core/utils/config';
import { Card } from "../../design-system";
import { UserProfileIcon, StarIcon } from "../../design-system/icons";
import { typography } from "../../design-system/tokens";

const Testimonials = () => {
  const renderStars = (rating) => {
    return Array.from({ length: 5 }, (_, index) => (
      <StarIcon key={index} size="sm" className="text-yellow-400" filled />
    ));
  };

  return (
    <WaveBackground>
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16 text-white">
        <div className="text-center mb-12">
          <h2 className={`${typography.h2Dark} text-white mb-4`}>
            What Our Users Say
          </h2>
          <p className={`${typography.bodyLargeDark} text-white`}>
            Join thousands of professionals who trust {APP_DOMAIN}
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
          {testimonialsData.map((testimonial) => (
            <Card 
              key={testimonial.id}
              variant="flat"
              hoverable
              className="bg-white bg-opacity-10 backdrop-blur-sm hover:bg-opacity-15"
            >
              {/* Profile Section */}
              <div className="flex items-center mb-4">
                <div className="w-16 h-16 bg-white bg-opacity-20 border-2 border-white border-opacity-30 rounded-full flex items-center justify-center mr-4 shadow-lg">
                  <UserProfileIcon size="xl" className="text-blue-200 dark:text-blue-200" />
                </div>
                <div>
                    <h3 className={`${typography.h5Dark} text-white`}>
                    {testimonial.name}
                  </h3>
                    <p className={`${typography.bodySmallDark} text-white`}>
                    {testimonial.profession}
                  </p>
                </div>
              </div>

              {/* Rating */}
              <div className="flex items-center mb-4">
                {renderStars(testimonial.rating)}
              </div>

              {/* Feedback */}
                <p className={`${typography.bodyDark} text-white`}>
                "{testimonial.feedback}"
              </p>
            </Card>
          ))}
        </div>
      </div>
    </WaveBackground>
  );
};

export default Testimonials;